/** Display helpers for the split name fields. */
export function fullName(person) {
    const parts = [person.firstName, person.lastName].map((p) => p?.trim()).filter(Boolean);
    return parts.length ? parts.join(' ') : null;
}
/** What to greet someone with: their first name, else their full name, else null. */
export function greetingName(person) {
    return person.firstName?.trim() || fullName(person);
}
/**
 * Splits a single free-text name into first/last on the last space.
 * Used only to migrate legacy single-field names and to interpret the single
 * `displayName` Google returns when it omits the structured fields.
 */
export function splitName(name) {
    const trimmed = name?.trim().replace(/\s+/g, ' ') ?? '';
    if (!trimmed)
        return { firstName: null, lastName: null };
    const cut = trimmed.lastIndexOf(' ');
    if (cut === -1)
        return { firstName: trimmed, lastName: null };
    return { firstName: trimmed.slice(0, cut), lastName: trimmed.slice(cut + 1) };
}
//# sourceMappingURL=people.js.map